export default function (date: string) {
  if (date) {
    return useDateFormat(date, 'ccc MMM Do YYYY').value
  }
}
